import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-white text-center py-6 relative">
      
      {/* Texto de Direitos Autorais */}
      <p className="text-md font-medium">
        &copy; {new Date().getFullYear()} Marineide Imóveis | Gerente Comercial ABC / SP
      </p>

      {/* Linha Decorativa */}
      <div className="w-20 h-1 bg-white mx-auto my-3 opacity-70"></div>

      {/* Links Rápidos */}
      <div className="flex justify-center space-x-6">
        <Link to="/" className="text-white hover:text-gray-200 transition">
          Home
        </Link>
        <Link to="/catalogo" className="text-white hover:text-gray-200 transition">
          Catálogo
        </Link>
        <Link to="/contato" className="text-white hover:text-gray-200 transition">
          Contato
        </Link>
      </div>

      {/* Ícone do cadeado para login */}
      <Link
        to="/login"
        className="absolute right-6 bottom-6 text-white text-2xl hover:text-gray-200 transition"
      >
        🔒
      </Link>
    </footer>
  );
}
